<template lang='html'>
<v-tab-item :id="name">
	<v-flex xl12 lg12 md12 xs12>
	    <div class="app-card mb-0">
	        <div class="app-card-title">
	            <h3>Recent Sale</h3>
	            <div class="app-contextual-link">
	                <v-menu origin="center center" transition="scale-transition" bottom>
	                    <v-btn icon slot="activator">
	                        <v-icon>ti-more-alt</v-icon>
	                    </v-btn>
	                    <v-list>
	                        <v-list-tile @click="">
	                            <v-icon class="mr-1">ti-settings</v-icon>
	                            <v-list-tile-title>Settings</v-list-tile-title>
	                        </v-list-tile>
	                        <v-list-tile @click="">
	                            <v-icon class="mr-1">ti-more-alt</v-icon>
	                            <v-list-tile-title>View More</v-list-tile-title>
	                        </v-list-tile>
	                        <v-list-tile @click="">
	                            <v-icon class="mr-1">ti-bell</v-icon>
	                            <v-list-tile-title>Disable notifications</v-list-tile-title>
	                        </v-list-tile>
	                    </v-list>
	                </v-menu>
	            </div>
	        </div>
	    </div>
	</v-flex>   
</v-tab-item>
</template>

<script>
/* eslint-disable */
export default {
    //template:``,
    name: '',
   	props:{
    	name:{type:String,default:'tab-shortcut'}
    },
    computed:{},
    methods:{},
    components:{},
    watch:{},
    directives: {},
    mounted :function(){},
    data () {
      return {
      }
    },
    filters: {
      //pluralize: (n, w) => n === 1 ? w : (w + 's'),
      capitalize: s => s.charAt(0).toUpperCase() + s.slice(1)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/front_sale/components/shortcut.vue